import { Directive } from '@angular/core';
import { clsx } from 'clsx';

@Directive({
  selector: '[statSummaryTitle]',
  host: {
    '[class]': 'hostClasses',
  },
})
export class StatSummaryTitleDirective {
  hostClasses = clsx('flex items-center gap-2xs font-semibold text-support');
}
